import React from 'react';
import reactStringReplace from 'react-string-replace';

export type MarketingText = {
  text: string;
  highlightText: string;
};

export const splitMarketingText = ({text, highlightText}: MarketingText) =>
  [text.replace(highlightText, '').trim(), highlightText.trim()] as const;

// unique unicode characters only for regex replacements
const startSymbol = '#始#';
const endSymbol = '@端@';
const captureRegex = new RegExp(`(?:${startSymbol})(.+?)(?:${endSymbol})`, 'g');

export const getTextWithHighlight = ({text, highlightText}: MarketingText): React.ReactNode => {
  const capturedText = text
    .split(/\s/g)
    .map((word) => (word === highlightText ? `${startSymbol}${word}${endSymbol}` : word))
    .join(' ');

  return reactStringReplace(capturedText, captureRegex, (m, index) => (
    <span className='highlight' key={index}>
      {m}
    </span>
  ));
};
